$(document).ready(function() {
  if ($("#scoreSubmit").length) {

    // Clock setup
    if ($("#event-clock").length) {
        var clockTimer = setInterval(clockProgress, 1000)
        function clockProgress(){
            var now = new Date();
            var h = now.getHours();
            var m = now.getMinutes();
            var s = now.getSeconds();
            h = clockCleanup(h);
            if (h > 12) { h = h - 12; }
            if (h == 0) { h = 12; }
            m = clockCleanup(m);
            s = clockCleanup(s);
            $("#event-clock").html(h + ":" + m + ":" + s);
        }
        function clockCleanup(i) {
            if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
            return i;
        }
    }

    // Name autocomplete
    $("#new_competitor_name").autocomplete({
      source: function( request, response ) {
        $.ajax( {
          url: "/app/events/"+$("#slug").val()+"/competitors/query",
          dataType: "json",
          data: {
            term: request.term
          },

          success: function( data ) {
            $("#new-competitor-info").show();
            console.log(data);
            $("#competitor_id").val("");

            response( data );
          },
          error: function( data ) {
            $("#competitor_id").val("");
          }
        });
      },
      minLength: 2,
      select: function( event, ui ) {
        $("#competitor_id").val(ui.item.id);
        console.log( "Selected: " + ui.item.value + " aka " + ui.item.id );
        $("#new-competitor-info").hide();
      }
    });

    // Score form validation
    $("#scoreSubmit").validate({
      rules: {
        competitor_id: {
          required: function(element) {
            return (!$("#new_competitor_first_name").hasClass('valid'));
          }
        },
        new_competitor_first_name: {
          required: function(element) {
            return (!$("#competitor_id").hasClass('valid'));
          }
        },
      },
      messages: {
        competitor_id: "Please select or enter a competitor",
        new_competitor_first_name: "Please select or enter a competitor",
      }
    });

    //populate data attributes based on selected round.

    function populateScoreSettings() {

      var secondaryScoring = $('#roundNameId').find(":selected").attr("data-secondary-scoring");
      var primaryIsTime = $('#roundNameId').find(":selected").attr("data-primary-time");
      var secondaryIsTime = $('#roundNameId').find(":selected").attr("data-secondary-time");
      var primaryDecimal = $('#roundNameId').find(":selected").attr("data-primary-decimal");
      var secondaryDecimal = $('#roundNameId').find(":selected").attr("data-secondary-decimal");

      $('.primary-score').each(function() {
        $(this).attr("data-secondary-scoring", secondaryScoring);
        $(this).attr("data-time", primaryIsTime);
        $(this).attr("data-decimal", primaryDecimal);
      });
      $('.secondary-score').each(function() {
        $(this).attr("data-secondary-scoring", secondaryScoring);
        $(this).attr("data-time", secondaryIsTime);
        $(this).attr("data-decimal", secondaryDecimal);
      });
      resetInputMasks();
    };

    populateScoreSettings();
    $('#roundNameId').change(function() {
      populateScoreSettings();
    });

    // resets all scores on the page based on their data-attributes for each .score
    // NOTE: This function is also in app/global.js. If changed here, also change there.
    function resetInputMasks() {
      // read data-attr which stores round enable_custom_settings
      $('.input-score').each(function() {
        var secondaryScoring = $(this).attr("data-secondary-scoring");

        var wrapper = $(this).parents('.score-input-wrapper').first();

        //formatts the columns based on whether or not secondary score is enabled.
        if (secondaryScoring != 1 && wrapper.hasClass('score-primary-input')) {
          wrapper.removeClass('col-md-6');
          wrapper.addClass('col-md-12');
        } else {
          wrapper.removeClass('col-md-12');
          wrapper.addClass('col-md-6');
        }

        if (secondaryScoring != 1 && wrapper.hasClass('score-secondary-input')) {
          wrapper.hide();
        } else {
          wrapper.show();
        }

        var isTime = $(this).attr("data-time");
        var decimalPlaces = $(this).attr("data-decimal");

        var decimalString = "";
        if (decimalPlaces > 0) {
          decimalString += ".";
          for (var i = 0; i < decimalPlaces; i++) {
            var decimalString = decimalString + '9';
          }
        }

        if (isTime) {
          //$(this).inputmask('remove');
          $(this).inputmask("99:99:99" + decimalString, {
            numericInput: true,
            placeholder: "0"
          });
        } else {
          $(this).inputmask("9{1,8}" + decimalString, {
            numericInput: true,
            placeholder: "0"
          });
        }
      });
    }

    // Stopwatch Setup
    if ($("#event-stopwatch").length) {
        var stopwatchRunning=false;
        var stopwatchTime;
        var startTime;
        var scoreFormatted=0;
        var scoreDecimal=$('#roundNameId').find(":selected").attr("data-primary-decimal");

        // Starting stopwatch
        $("#event-stopwatch-start-stop").click(function(){
          if(stopwatchRunning==false){
              startTime = new Date();
              stopwatchTime = setInterval(function(){stopwatchProgress(startTime)}, 1);
              $("#event-stopwatch-start-stop").html("Stop");
              stopwatchRunning=true;
              $("#event-stopwatch-start-stop").removeClass('btn-success');
              $("#event-stopwatch-start-stop").addClass('btn-danger');
          } else {
              // Stop stopwatch
              clearInterval(stopwatchTime);
              $("#event-stopwatch-start-stop").html("Start");
              stopwatchRunning=false;
              $("#event-stopwatch-start-stop").removeClass('btn-danger');
              $("#event-stopwatch-start-stop").addClass('btn-success');
          }
        });

        // Clearing stopwatch
        $("#event-stopwatch-clear").click(function(){
          scoreFormatted=0;
          $("#score_primary_1").val(scoreFormatted);
          clearInterval(stopwatchTime);
          stopwatchRunning=false;
        });

        //Calculates the change of the stopwatch
        function stopwatchProgress(start){
              var now = new Date();

              var dif = new Date(0,0,0,0,0,0,now-start);

              var h = dif.getHours();
              var m = dif.getMinutes();
              var s = dif.getSeconds();
              var ms = dif.getMilliseconds();

              h = clockCleanup(h,2);
              m = clockCleanup(m,2);
              s = clockCleanup(s,2);
              ms = clockCleanup(ms,3);
              scoreFormatted= h + m + s + (ms+"0").substring(0,scoreDecimal);
              $("#score_primary_1").val(scoreFormatted);

              return true;
        }

        // Managae zeros
        function clockCleanup(i,n) {
            var l=(i+"").length;
            for (var j = l; j < n; j++) {
              i = "0" + i;
            }
            return i;
        }
      }
  };


});
